<template>
    <div>
        <el-form ref="form" :rules="rules" :model="form" label-width="100px">
            <el-row :gutter="10">
                <el-col :span="9">
                    <el-form-item :label="$t('public.reason')" prop="reasonId">
                        <el-select style="width:100%" v-model="form.reasonId" :placeholder="$t('integration.please_select_a_reason')">
                            <el-option v-for="item in resonArray" :key="item.id" :label="item.title" :value="item.id"> </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('public.handler')" prop="processor">
                        <el-checkbox @change="customFn" v-model="form.customChecked">{{ $t('integration.customize_users') }}</el-checkbox>
                        <el-checkbox @change="currentFn" v-model="form.currentChecked">{{ $t('integration.current_user') }}</el-checkbox>
                        <el-input :disabled="form.currentChecked" style="width:100%;margin-top: 10px;" type="text" v-model="form.processor" :placeholder="$t('integration.please_fill_in_the_handler')">
                        </el-input>
                    </el-form-item>

                    <el-form-item :label="$t('public.table_desc')" prop="desc">
                        <el-input v-model="form.desc" type="textarea" :autosize="{ minRows: 4, maxRows: 8 }" style="width:100%" maxlength="250" show-word-limit> </el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button type="primary" @click="handleClick">
                            {{ $t('integration.handle') }}
                        </el-button>
                    </el-form-item>
                </el-col>
                <el-col :span="14">
                    <el-form-item :label="$t('public.content')" label-width="60px" prop="related">
                        <div class="content-class">
                            <ul class="ul-class">
                                <li v-for="item in getAbList" :key="item.id">
                                    <div class="title-class">
                                        <template>
                                            {{ $t(abTextInfoConvert(item.exType - 1).title) }}
                                        </template>
                                    </div>
                                    <div class="content-children-class">
                                        <!-- 不同的异常对应不同的图标 -->
                                        <i v-icon:theme="['abTextInfoConvert', item.exType - 1]"></i>

                                        <!-- <i style="margin-right: 5px;" :class="item.$icon"></i> -->

                                        <span>{{ item.carrierDeviceName }}</span>
                                        <span> - </span>
                                        <span>{{ $timetransition(item.recordTime) }}</span>
                                    </div>
                                    <div class="icon-class" @click="delRow(item.id)">
                                        <i class="el-icon-circle-close"></i>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </el-form-item>
                </el-col>
                <el-col :span="1">
                    <!-- <i class="el-icon-question" style="font-size: 16px;
        cursor: pointer;"></i> -->
                    <div class="question">
                        <IconDesc :iconDesc="abIconDesc"></IconDesc>
                    </div>
                </el-col>
            </el-row>
        </el-form>
        <chaoozeRegion v-bind="$attrs" @pushDataFn="pushDataFn" :childrenList="childrenList" />
    </div>
</template>

<script>
import chaoozeRegion from '../chaoozeRegion.vue';
import IconDesc from '@/components/IconDesc/IconDesc.vue';
import { exHandle, exReasons } from '@/api/modules/abnormal.js';
import { abTextInfoConvert } from '@/utils/convert.js';
export default {
    name: 'handleCom',
    components: { chaoozeRegion, IconDesc },
    computed: {
        currentName() {
            return this.$store.getters.userInfo.user.account;
        },
        abIconDesc: () => [
            {
                // 图标解释标题
                title: $t($t('integration.type_of_anomaly')),
                // 图标类型
                type: 'abTextInfo'
            }
        ]
    },
    data() {
        return {
            abTextInfoConvert,
            rules: {
                reasonId: [{ required: true, message: $t('integration.reason_cannot_be_empty'), trigger: 'change' }],
                processor: [
                    { required: true, message: $t('integration.handler_cannot_be_blank'), trigger: ['blur', 'change'] },
                    {
                        max: 30,
                        message: $t('integration.length_is_less_than_30'),
                        trigger: ['blur', 'change']
                    },
                    {
                        trigger: ['blur', 'change'],
                        validator: (rule, value, callback) => {
                            if (!this.form.currentChecked && !this.form.customChecked) {
                                callback(new Error($t('integration.check_at_least_one_method')));
                            }
                            callback();
                        }
                    }
                ],
                related: [{ type: 'array', required: true, message: $t('integration.content_cannot_be_empty'), trigger: 'change' }]
            },
            form: {
                reasonId: '',
                processor: '',
                customChecked: false,
                currentChecked: true,
                desc: '',
                related: []
            },
            resonArray: [],
            getAbList: [],
            childrenList: []
        };
    },
    mounted() {
        // console.log(this.$attrs.rowData);
        this.getReason();
        this.form.processor = this.currentName;
    },
    methods: {
        getReason() {
            const { rowData } = this.$attrs;
            exReasons({ scope: rowData.scope_id }).then(({ result }) => {
                this.resonArray = result;
            });
        },

        customFn(e) {
            this.form.currentChecked = false;
        },
        currentFn(e) {
            this.form.customChecked = false;
            if (e) {
                this.form.processor = this.currentName;
            }
        },
        pushDataFn(rows, row, selected) {
            // rows.forEach(item => {
            //     let info = this.abTextInfo[String(item.ex_catalog)]

            //     this.$set(item, '$title', info.text)
            //     this.$set(item, '$icon', info.icon)
            // })
            if (selected === 'allCancel') {
                this.getAbList = this.getAbList.filter(item => {
                    return !rows.some(ele => ele.id === item.id);
                });
            } else if (!selected || selected === 0) {
                this.getAbList = this.getAbList.filter(item => item.id !== row.id);
            } else {
                // 去重
                this.getAbList = this.generOdd([...this.getAbList, ...rows]);
            }
            // console.log("rows==>", this.getAbList);
        },
        // 两个对象数组去重
        generOdd(filterData) {
            const obj = {};
            // 2 数组去重
            filterData = filterData.reduce((pre, cur) => {
                obj[cur.id] ? '' : (obj[cur.id] = true && pre.push(cur));
                return pre;
            }, []);
            return filterData;
        },
        async justify() {
            // 校验成功则方法自动返回true，校验方法报错则说明校验失败，返回false
            try {
                return await this.$refs.form.validate();
            } catch (error) {
                return false;
            }
        },
        // 处理数据
        async handleClick() {
            this.form.related = this.getAbList;
            const query = { ...this.form };
            query.exId = this.$attrs.rowData.id;

            // 使用自定义用户
            if (query.customChecked) {
                query.useCurrentUser = 0;
            } else {
                query.useCurrentUser = 1;
            }

            this.$delete(query, 'currentChecked');
            this.$delete(query, 'customChecked');

            const flag = await this.justify();
            if (!flag) return;
            exHandle(query).then(({ result, state }) => {
                if (state.code === 200) {
                    // 关闭窗口 刷新对应列表的对应数据的处理次数
                    this.$message.success($t('integration.processed_c__processing_information_can_be_viewed_in_the_record'));
                    this.$emit('updateClose', { id: query.exId, time: result.time });
                }
            });
        },
        delRow(id) {
            this.getAbList = this.getAbList.filter(item => item.id !== id);
            this.childrenList = this.getAbList;
        }
    }
};
</script>

<style lang="scss" scoped>
.content-class {
    padding: 10px;
    width: 100%;
    height: 252px;
    overflow-y: auto;
    border: 1px solid #ccc;
    box-sizing: border-box;

    .ul-class {
        height: 100%;
        overflow-y: auto;

        li {
            height: 30px;
            width: 100%;
            // padding: 5px;
            box-sizing: border-box;
            border: 1px solid var(--primary-color);
            border-radius: 2px;
            display: flex;
            align-items: center;
            margin-bottom: 10px;
        }

        .title-class {
            width: 110px;
            height: 100%;
            line-height: 30px;
            text-align: center;
            color: #fff;
            background-color: var(--primary-color);
            overflow: hidden;
        }

        .content-children-class {
            flex: 1;
            height: 100%;
            line-height: 30px;
        }

        .icon-class {
            width: 30px;
            height: 30px;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-left: 1px solid var(--primary-color);

            i {
                font-weight: bold;
                font-size: 16px;
            }
        }
    }
}
</style>
